module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "feedback-component grey lighten-3 text-xs-center primary--text",
    staticStyle: {
      "position": "absolute",
      "right": "0px",
      "top": "50px",
      "height": "42px"
    }
  }, [_c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "small": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.startTour()
      }
    }
  }, [_vm._v("\n          Start Tour\n          "), _c('v-icon', {
    staticClass: "primary--text pl-2"
  }, [_vm._v("flag")])], 1), _vm._v(" "), (['opportunities', 'history', 'directory'].includes(_vm.module)) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "small": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openModal()
      }
    }
  }, [_vm._v("\n          Send Feedback\n          "), _c('v-icon', {
    staticClass: "primary--text pl-2"
  }, [_vm._v("feedback")])], 1) : _vm._e(), _vm._v(" "), (['opportunities', 'history', 'directory'].includes(_vm.module)) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "small": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSupport()
      }
    }
  }, [_vm._v("\n        Help\n        "), _c('v-icon', {
    staticClass: "primary--text pl-2"
  }, [_vm._v("help")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('feedback-modal', {
    attrs: {
      "dialog": _vm.modalTrigger,
      "module": _vm.module
    },
    on: {
      "cancel": function($event) {
        _vm.modalTrigger = false
      }
    }
  }), _vm._v(" "), _c('support-modal', {
    attrs: {
      "dialog": _vm.supportTrigger
    },
    on: {
      "cancel": function($event) {
        _vm.supportTrigger = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60c3fb49","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeedbackComponent.vue
// module id = 957
// module chunks = 13 16 19 20 21 22